import { Category } from "../Model/Category";
import { CategoryRepository } from "../Repository/CategoryRepository";



export interface UpdateCategoryUseCase {
    invoke: (data: Category) => Promise<boolean>;
  }
  
  export class UpdateCategory implements UpdateCategoryUseCase {
    private categoryRepo: CategoryRepository;
    constructor(_CategoryRepo: CategoryRepository) {
      this.categoryRepo = _CategoryRepo;
    }
  
    async invoke(data: Category){
       
        if(!data){
            throw new Error(
                "Your todo should have at leat 2 characters."
              );
        }
         
        const update  = await this.categoryRepo.updateCategory(data);
        return update;
    }
  }